import React, { useEffect, useState, useRef } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/src/ReactCrop.scss";
import FileReaderInput, { contextType } from "react-file-reader-input";

function Image({ src, onChangeCrop, onLoad }) {
    const [imgSrc, setImgSrc] = useState(src);

    const [crop, setCrop] = useState({
        unit: "%",
        x: 0,
        y: 0,
        width: 100,
        height: 100,
    });

    const refImage = useRef(null);

    useEffect(() => {
        const image = refImage.current;
        image.onload = function () {
            const ratio = image.width / image.height;
            if (ratio > 1485 / 2100) {
                const widthReduit = (1485 / 2100) * image.height * 0.98;
                const rapport = (100 * widthReduit) / image.width;
                setCrop({
                    unit: "%",
                    x: (100 - rapport) / 2,
                    y: 1,
                    width: rapport,
                    height: 98,
                });
            } else {
                const heightReduit = (2100 / 1485) * image.width * 0.98;
                const rapport = (100 * heightReduit) / image.height;
                setCrop({
                    unit: "%",
                    y: (100 - rapport) / 2,
                    x: 1,
                    width: 98,
                    height: rapport,
                });
            }
        };
    }, [imgSrc]);

    const handleChangeImage = (e) => {
        e.preventDefault();
        if (
            e.target.files &&
            e.target.files.length === 1 &&
            e.target.files[0].type.match("image.*")
        ) {
            const fichier = e.target.files[0];
            const reader = new FileReader();
            reader.onload = function (event) {
                setImgSrc(event.target.result);
                onChangeCrop(undefined);
            };
            reader.readAsDataURL(fichier);
        }
    };
    const handleChangeCrop = (c, pc) => {
        setCrop(pc);
    };
    const handleCompleteCrop = (c, pc) => {
        const image = refImage.current;
        if (c.width === 0 && c.height === 0) {
            onChangeCrop(undefined);
        } else {
            const canvas = document.createElement("canvas");
            const scaleX = image.naturalWidth / image.width;
            const scaleY = image.naturalHeight / image.height;
            canvas.width = Math.floor(c.width * scaleX);
            canvas.height = Math.floor(c.height * scaleY);
            const cropX = c.x * scaleX;
            const cropY = c.y * scaleY;
            canvas
                .getContext("2d")
                .drawImage(
                    image,
                    cropX,
                    cropY,
                    c.width * scaleX,
                    c.height * scaleY,
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );
            onChangeCrop(canvas.toDataURL("image/png"));
        }
    };
    return (
        <div className="col-6">
            <FileReaderInput
                accept="image/*"
                onChange={(e) => handleChangeImage(e)}
            >
                <button className="btn btn-primary mt-0">
                    Changer d'image
                </button>
            </FileReaderInput>
            <ReactCrop
                crop={crop}
                aspect={1485 / 2100}
                onChange={handleChangeCrop}
                onComplete={handleCompleteCrop}
            >
                <img src={imgSrc} ref={refImage} />
            </ReactCrop>
        </div>
    );
}

export default Image;
